import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-tech-sidenav",
  templateUrl: "./tech-sidenav.component.html",
})
export class TechSidenavComponent implements OnInit {
  accessmanagement: any;
  selectedlang: any = {};
  tcCode = "";
  testCenterName = "";
  usertype: any = "";
  currentURL: any = "";
  dashboardMenu = {
    techscheduleappointmentmenu: false,
    techvacationappointmentmenu: false,
  };
  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    this.usertype = sessionStorage.getItem("usertype");
    this.accessmanagement = JSON.parse(
      localStorage.getItem("accessmanagement")
    );
    this.setaccessmanagement(this.accessmanagement);
    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode").toString();
    }
    if (localStorage.getItem("testCenterName") != null) {
      this.testCenterName = localStorage.getItem("testCenterName");
    }
    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
    if (sessionStorage.getItem("type")) {
      this.checkURL(sessionStorage.getItem("type"));
    } else {
      this.checkURL("vacation-management");
    }
  }
  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }

  setaccessmanagement(access) {
    for (let i = 0; i < access.length; i++) {
      if (access[i].value.length > 0 && access[i].key === "Operations") {
        for (let j = 0; j < access[i].value.length; j++) {
          if (sessionStorage.getItem("usertype") === "2") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Technician Schedule"
            ) {
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Technician Schedule"
              ) {
                this.dashboardMenu.techscheduleappointmentmenu =
                  access[i].value[j].admin;
              }
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Technician Vacation"
              ) {
                this.dashboardMenu.techvacationappointmentmenu =
                  access[i].value[j].admin;
              }
            }
          } else if (sessionStorage.getItem("usertype") === "3") {
            if (
              access[i].value[j].accessManagement.accessManagement ===
              "Technician Schedule"
            ) {
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Technician Schedule"
              ) {
                this.dashboardMenu.techscheduleappointmentmenu =
                  access[i].value[j].frontDesk;
              }
              if (
                access[i].value[j].accessManagement.subMenu ===
                "Technician Vacation"
              ) {
                this.dashboardMenu.techvacationappointmentmenu =
                  access[i].value[j].frontDesk;
              }
            }
          }
        }
      }
    }
  }
}
